<template>
    <div>
        <v-container v-if="showMain == true">
            <v-layout class="reportPanel">
                <v-flex xs12 sm8 md8 lg8 xl8>
                    <canvas id="student-status-chart"/>
                </v-flex>
            </v-layout>
            <v-layout class="reportPanel">
                <v-flex xs4 sm4 md4 lg4 xl4 style="text-align: center;">
                    <div class="label">
                        ĐIỂM TRUNG BÌNH
                    </div>
                    <div class="content" style="font-size: 50px;font-weight: bold">
                        {{averateMark}}
                    </div>
                </v-flex>
                <v-flex xs8 sm8 md8 lg8 xl8>
                    <canvas id="mark-report-chart"/>
                </v-flex>
            </v-layout>
            <v-layout v-if="exerciseType == 6">
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <div class="groupHeader">Phân tích năng lực cả lớp</div>
                </v-flex>
            </v-layout>
            <v-layout v-if="exerciseType == 6">
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-data-table :headers="subjectHeaders" class="elevation-1"
                                  :items="markBySubject" hide-actions>
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.subject }}</td>
                            <td class="text-xs-right">{{ props.item.average }}%</td>
                            <td class="text-xs-left">
                                <v-progress-linear :value="props.item.average">
                                    <template v-slot="{ value }">
                                        <strong>{{ Math.ceil(value) }}%</strong>
                                    </template>
                                </v-progress-linear>
                            </td>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
            <v-layout v-if="exerciseType == 6">
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <div class="groupHeader">Kết quả từng câu</div>
                </v-flex>
            </v-layout>
            <v-layout v-if="exerciseType == 6">
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-data-table :headers="exerciseReportHeaders" class="elevation-1"
                                  :items="exerciseReport" hide-actions>
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item["question"] }}</td>
                            <td class="text-xs-right">{{ props.item["true"] }}</td>
                            <td class="text-xs-right">{{ props.item["false"] }}</td>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import DoQuiz from "../doQuiz";
    import DoEssay from "../doEssay";

    export default {
        name: "answer-analysis",
        components: {DoEssay, DoQuiz},
        props: {
            classId: {
                type: String | Number,
                default: null
            },

            exerciseId: {
                type: String | Number,
                default: null
            },

            exercise: {
                type: Object,
                default: null
            },

            exerciseType: {
                type: String | Number,
                default: null
            },
        },

        data: () => ({
            studentId: null,
            showMain: true,
            averateMark: null,
            exerciseReportHeaders: [
                {
                    text: "Câu hỏi",
                    align: "left",
                    sortable: false,
                    value: "question"
                },
                {
                    text: "Đúng",
                    align: "right",
                    sortable: false,
                    value: "true"
                },
                {
                    text: "Sai",
                    align: "right",
                    sortable: false,
                    value: "false"
                }
            ],
            exerciseReport: [],
            subjectHeaders: [
                {
                    text: "Chủ đề",
                    align: "left",
                    sortable: false,
                    value: "subject"
                },
                {
                    text: "Trung bình",
                    align: "right",
                    sortable: false,
                    value: "average"
                },
                {
                    text: "Tỉ lệ",
                    align: "right",
                    sortable: false,
                    value: "average"
                }

            ],
            markBySubject: []
        }),

        computed: {},

        watch: {},

        created() {
            this.init();
        },

        methods: {
            init: function () {
                this.getStudentCountByStatus();
                this.getMarkReport();
                if (this.exerciseType == 6) {
                    this.getQuizExerciseReport();
                    this.getQuizSubjectAverage();
                }
            },

            getStudentCountByStatus: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/countStudentByStatus?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.mapStatus = data;
                            const ctx = document.getElementById('student-status-chart');
                            const chart = new Chart(ctx, {
                                type: 'pie',
                                data: {
                                    labels: ["Chưa nộp", "Đã nộp", "Đã chấm", "Đã trả bài"],
                                    datasets: [
                                        {
                                            data: [this.mapStatus[0], this.mapStatus[2], this.mapStatus[3], this.mapStatus[4]],
                                            backgroundColor: [
                                                'orange', // Blue
                                                '#ffcd56',
                                                '#36a2eb',
                                                '#ff6384'
                                            ],
                                        }
                                    ]
                                },
                                options: {
                                    title: {
                                        display: true,
                                        text: 'Biểu đồ thống kê trạng thái nộp bài cùa học sinh'
                                    }

                                },
                            });

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            getMarkReport: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getMarkReportOfExercise?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.mapMark = data;
                            this.averateMark = data[0];
                            const ctxmark = document.getElementById('mark-report-chart');
                            const chartmark = new Chart(ctxmark, {
                                type: 'doughnut',
                                data: {
                                    labels: ["<50%", "50%-80%", ">80%"],
                                    datasets: [
                                        {
                                            data: [this.mapMark[5], this.mapMark[8], this.mapMark[10]],
                                            backgroundColor: [
                                                '#36a2eb',
                                                'orange', // Blue
                                                '#ffcd56',
                                                '#ff6384'
                                            ],
                                        }
                                    ]
                                },
                                options: {
                                    title: {
                                        display: true,
                                        text: 'Biểu đồ thống kê điểm cùa học sinh'
                                    }
                                },
                            });

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            getQuizExerciseReport: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getQuizExerciseReport?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.exerciseReport = [];
                            for (let key in data) {
                                let ob = {
                                    'question': "Câu " + (parseInt(key) + 1),
                                    'true': data[key]['true'],
                                    'false': data[key]['false']
                                };
                                this.exerciseReport.push(ob);
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            getQuizSubjectAverage: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getQuizSubjectAverage?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.markBySubject = [];
                            for (let key in data) {
                                let ob = {
                                    'subject': key,
                                    'true': data[key]['true'],
                                    'false': data[key]['false'],
                                    'average': data[key]['true'] * 100 / (data[key]['true'] + data[key]['false'])
                                };
                                this.markBySubject.push(ob);
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            viewStudentAnswer: function (userId) {
                this.studentId = userId;
                this.showMain = false;
            },

            getStatusText: function (status) {
                switch (status) {
                    case 0:
                    case 1:
                        return this.$t('lang.exercise.doing');
                        break;
                    case 2:
                        return this.$t('lang.exercise.sent');
                        break;
                    case 3:
                        return this.$t('lang.exercise.marked');
                        break;
                    case 4:
                        return this.$t('lang.exercise.returned');
                        break;
                    default:
                        return "";

                }
            },

            back: function () {
                this.showMain = true;
                this.init();
            }
        }
    };
</script>